import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { settingsApi } from '@/api/index';

export const fetchSettings = createAsyncThunk(
  'settings',
  async (params, thunkAPI) => {
    try {
      const response = await settingsApi.get();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
